import { useEffect, useState, useContext, useMemo } from 'react';
import api from '../api';
import { UserContext } from '../context/UserContext';
import AvatarImg from '../components/AvatarImg';
import './home.css';

export default function ReferralOverview() {
  const { user } = useContext(UserContext);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [min, setMin] = useState('');
  const [showZero, setShowZero] = useState(false);

  const load = async () => {
    setLoading(true); setError('');
    try {
      const params = {};
      if (search.trim()) params.q = search.trim();
      if (!showZero && min.trim()) params.min = min.trim();
      if (!showZero && !min.trim()) params.min = '1';
      const { data } = await api.get('/admin/referrals', { params });
      setItems(Array.isArray(data?.items) ? data.items : []);
    } catch (e) {
      setError(e?.response?.data?.error || e.message || 'Fehler beim Laden');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const totalReferred = useMemo(() => items.reduce((s,i)=>s+i.referralCount,0), [items]);

  return (
    <div style={{width:'100vw',margin:0,padding:0}}>
      <div className="home-page" style={{width:'100%',margin:0,padding:0}}>
        <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
          <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Mitglieder-Werbung Übersicht</h2>
          <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Sieh wie viele aktive Mitglieder durch bestehende Mitglieder geworben wurden.</p>
        </section>

        <section style={{ width:'100%', margin:0, padding:0, display:'flex', justifyContent:'center', position:'relative', left:'-120px' }}>
          <div className="highlight-card" style={{gap:18,padding:32,width:'100%',maxWidth:900, boxSizing:'border-box'}}>
            <div className="referral-controls">
              <input
                className="hero-btn-secondary"
                style={{ padding:'12px 18px', fontSize:'1rem', width:'100%' }}
                placeholder="Suche Recruiter (Name)"
                value={search}
                onChange={e=>setSearch(e.target.value)}
              />
              <input
                className="hero-btn-secondary"
                style={{ padding:'12px 18px', fontSize:'1rem', width:'100%' }}
                placeholder="Min. Anzahl"
                value={min}
                onChange={e=>setMin(e.target.value)}
                disabled={showZero}
              />
              <label className="referral-controls-checkbox">
                <input type="checkbox" checked={showZero} onChange={e=>setShowZero(e.target.checked)} />
                auch 0 anzeigen
              </label>
              <div className="referral-controls-actions">
                <button className="hero-btn-primary" onClick={load} disabled={loading}>{loading?'Lade...':'Aktualisieren'}</button>
                <button className="hero-btn-secondary" onClick={()=>{ setSearch(''); setMin(''); setShowZero(false); load(); }}>Reset</button>
              </div>
            </div>
            <div style={{marginBottom:12,fontSize:13,opacity:.85}}>
              <b>{items.length}</b> Recruiter · <b>{totalReferred}</b> geworbene aktive Mitglieder
            </div>
            {error && <div style={{color:'#ff8484',marginBottom:12}}>{error}</div>}
            <div style={{overflowX:'auto'}}>
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <thead>
                  <tr style={{textAlign:'left',borderBottom:'1px solid #ddd'}}>
                    <th style={{padding:'8px'}}>Recruiter</th>
                    <th style={{padding:'8px'}}>Anzahl</th>
                    <th style={{padding:'8px'}}>Geworbene aktive Mitglieder</th>
                  </tr>
                </thead>
                <tbody>
                  {items.filter(i => showZero || i.referralCount > 0).map(r => (
                    <tr key={r.id} style={{borderBottom:'1px solid #eee'}}>
                      <td style={{padding:'8px',minWidth:200}}>
                        <div style={{display:'flex',alignItems:'center',gap:10}}>
                          <AvatarImg src={r.avatarUrl || '/avatars/default-avatar.png'} alt={r.username} size={34} />
                          <div style={{display:'flex',flexDirection:'column'}}>
                            <a href={`/u/${r.id}`} style={{color:'#32CD89',textDecoration:'underline',fontWeight:600}}>{r.displayName || r.username}</a>
                            <span style={{fontSize:12,opacity:.7}}>@{r.username}</span>
                          </div>
                        </div>
                      </td>
                      <td style={{padding:'8px',fontWeight:700}}>{r.referralCount}</td>
                      <td style={{padding:'8px'}}>
                        {r.referralCount === 0 && <span style={{opacity:.4}}>Keine</span>}
                        {r.referralCount > 0 && (
                          <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
                            {r.referrals.map(x => (
                              <a key={x.id} href={`/u/${x.id}`} title={x.displayName||x.username} style={{textDecoration:'none'}}>
                                <span style={{background:'rgba(50,205,137,0.12)',border:'1px solid rgba(50,205,137,0.4)',color:'#32CD89',borderRadius:12,padding:'3px 10px',fontSize:12,fontWeight:600}}>{x.displayName && x.displayName!==x.username ? `${x.displayName} (@${x.username})` : `@${x.username}`}</span>
                              </a>
                            ))}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                  {items.filter(i => showZero || i.referralCount > 0).length === 0 && (
                    <tr><td colSpan={3} style={{padding:'16px',opacity:.6}}>Keine Ergebnisse.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <section className="cta-section" style={{width:'100%',margin:0,padding:0}}>
          <div style={{width:'100%',margin:0,padding:0, position:'relative', left:'-120px'}}>
            <h2 className="cta-title">Wachstum durch Mitglieder</h2>
            <p className="cta-desc">Diese Übersicht zeigt, wie aktiv unsere Community beim Werben neuer Mitglieder ist.</p>
          </div>
        </section>
      </div>
    </div>
  );
}
